import { Link } from "react-router-dom";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import { Bars2Icon } from "@heroicons/react/24/outline";

const WorkoutTemplateCard = (props) => {
  const amountOfExercises = props.exercises.length;

  const amountOfExercisesMessage =
    amountOfExercises === 1 ? "1 Exercise" : `${amountOfExercises} Exercises`;
  return (
    <div className={`relative ${props.className}`}>
      <Link
        to={`/programs/${props.program}/workout-templates/${props._id}`}
        type="button"
        className="grid grid-cols-[auto_1fr_auto] content-center bg-white rounded-md shadow-sm mb-1 border border-gray-300"
      >
        <div className="h-full bg-gray-300 rounded-l-sm flex items-center p-2">
          <Bars2Icon className="h-5 text-gray-900" />
        </div>
        <div className="p-2 overflow-hidden pr-6">
          <h3 className="text-base font-medium text-gray-900  w-full whitespace-nowrap overflow-hidden text-ellipsis">
            {props.name || "Untitled Program Workout"}
          </h3>
          <p className="text-sm text-gray-500">{amountOfExercisesMessage}</p>
        </div>
        <div className="flex flex-row items-center"></div>
      </Link>
      <div className="absolute top-0 right-0">
        <DropdownMenu
          menuItems={["Delete", "Duplicate"]}
          parentId={props._id}
          onDeleteClicked={props.onOpenDeleteWorkoutTemplateModal}
          onDuplicateClicked={props.onDuplicate}
        />
      </div>
    </div>
  );
};

export default WorkoutTemplateCard;
